import { useEffect } from "react";
import { useSyncExternalStore } from "../../../utilities/hooks/useSyncExternalStore";
import { ROUTES } from "../../../consts/routes";

const IDLE_MODAL_KEY = "idle_modal_open";

export function useModalState() {
  const setState = (newValue) => {
    localStorage.setItem(IDLE_MODAL_KEY, newValue);
    dispatchEvent(
      new StorageEvent("storage", { key: IDLE_MODAL_KEY, newValue }),
    );
  };

  const getSnapshot = () => localStorage.getItem(IDLE_MODAL_KEY);

  const subscribe = (listener) => {
    window.addEventListener("storage", listener);
    return () => void window.removeEventListener("storage", listener);
  };

  const value = useSyncExternalStore(subscribe, getSnapshot);

  useEffect(() => {
    if (window.location.href.includes(ROUTES.login())) {
      setState(false);
    }
  }, [window.location.href]);

  return {
    isOpen: () => value === "true",
    open: () => setState(true),
    close: () => setState(false),
  };
}
